<template>
  <a-drawer title="查询" :visible="visible" @close="handleClose" placement="left" :mask="false" :width="300">
    <div class="query-content">
      <a-form-model :model="form" :rules="rules" ref="form">
        <a-form-model-item label="查询图层" prop="queryType">
          <a-select v-model="form.queryType" placeholder="请选择查询图层">
            <a-select-option value="search_pipe_network">物探点</a-select-option>
            <a-select-option value="search_gis_pipe_line">管线</a-select-option>
            <a-select-option value="gis_pipe_network_user_data">用户数据</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="查询属性" prop="queryProperty" v-show="form.queryType === 'gis_pipe_network_user_data'">
          <a-select v-model="form.queryProperty" placeholder="请选择查询属性">
            <a-select-option value="user_point_number">用户编码</a-select-option>
            <a-select-option value="user_point_name">用户名称</a-select-option>
            <a-select-option value="class_no">分类编码</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="查询属性" prop="queryProperty" v-show="form.queryType === 'search_pipe_network'">
          <a-select v-model="form.queryProperty" placeholder="请选择查询属性">
            <a-select-option value="texture_material">材质</a-select-option>
            <a-select-option value="caliber">口径</a-select-option>
            <a-select-option value="class_no">分类编码</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="查询属性" prop="queryProperty" v-show="form.queryType === 'search_gis_pipe_line'">
          <a-select v-model="form.queryProperty" placeholder="请选择查询属性">
            <a-select-option value="pipe_diameter">管径</a-select-option>
            <a-select-option value="pipe_material">管材</a-select-option>
            <a-select-option value="line_class_no">分类编码</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="查询属性值" prop="queryPropertyValue" v-if="hasValidQueryRule()">
          <a-select v-model="form.queryPropertyValue" mode="tags" style="width: 100%" placeholder="选择属性值"
            @change="handleChange">
            <a-select-option v-for="item in textureList" :key="item" :value="item">{{ item }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="查询属性值" prop="queryPropertyValue"
          v-else-if="form.queryType && form.queryProperty && !hasValidQueryRule()">
          <a-input v-model="form.queryPropertyValue" placeholder="请输入查询属性值" />
        </a-form-model-item>

        <a-form-model-item label="管网长度" prop="lineLength" v-show="lineLength > 0" :label-col="{ span: 8 }"
          :wrapper-col="{ span: 16 }">
          <span>{{ lineLength }} m(米)</span>
        </a-form-model-item>
        <!-- 操作按钮 -->
        <a-form-model-item>
          <div style="text-align: center;">
            <a-space v-show="form.queryType && form.queryProperty">
              <a-button type="primary" @click="handleQuery">查询</a-button>
              <a-button @click="handleReset">重置</a-button>
            </a-space>
          </div>
        </a-form-model-item>

      </a-form-model>
    </div>
  </a-drawer>
</template>

<script>
import { listPipeNetworkByGroupProperties, listByGroupProperties } from '@/api/manage'

export default {
  name: 'QueryDrawer',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: {
        queryType: undefined,
        queryProperty: undefined,
        queryPropertyValue: undefined
      },
      textureList: [],
      queryRules: {
        'search_pipe_network-texture_material': 'texture_material',
        'search_pipe_network-caliber': 'caliber',
        'search_gis_pipe_line-pipe_diameter': 'pipe_diameter',
        'search_gis_pipe_line-pipe_material': 'pipe_material',
      },
      getLineCQLUrl: '/pipe-network/gis/pipe-lines/location/cql',
      getNetWorkCQLUrl: '/pipe-network/gis/pipe-networks/location/cql',

      getLineUrl: '/pipe-network/gis_class_user_water_meters/page',
      getLineLengthUrl: '/pipe-network/gis/pipe-lines/getLength',

      getUserDataUrl: '/pipe-network/gis_class_user_water_meters/page',
      rules: {
        queryType: [{ required: true, message: '请选择查询图层' }],
        queryProperty: [{ required: true, message: '请选择查询属性' }],
        queryPropertyValue: [{ required: true, message: '请填写查询属性值' }]
      },
      lineLength: 0,
      componentsId: 'query_in_query_drawer', // 组件ID 负责清理地图图层
      wmsData: {
        layer: '',
        cqlString: '',
      }
    }
  },
  watch: {
    'form.queryType': {
      handler (newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          // 重置相关字段为默认值
          this.form.queryProperty = undefined;
          this.form.queryPropertyValue = undefined;
          this.textureList = [];
        }
      }
    },
    'form.queryProperty': {
      handler (newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          // 清空查询属性值
          this.form.queryPropertyValue = undefined;
          // 获取新的查询类型列表
          this.getQueryTypeList();
        }
      }
    }
  },
  methods: {
    // 将下划线格式转换为驼峰格式
    toCamelCase (str) {
      return str.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());
    },

    // 计算 LineString 的中心点坐标
    calculateLineStringCenter (coordinates) {
      if (!coordinates || coordinates.length === 0) {
        return null;
      }

      let sumLng = 0;
      let sumLat = 0;
      coordinates.forEach(coord => {
        sumLng += coord[0];
        sumLat += coord[1];
      });

      return [sumLng / coordinates.length, sumLat / coordinates.length];
    },

    // 根据 GeoJSON 类型获取坐标
    getCoordinatesByGeoJsonType (geoJson) {
      if (!geoJson || !geoJson.type || !geoJson.coordinates) {
        return null;
      }

      if (geoJson.type === 'Point') {
        // Point 类型直接返回 coordinates
        return geoJson.coordinates;
      } else if (geoJson.type === 'LineString') {
        // LineString 类型计算中心点
        return this.calculateLineStringCenter(geoJson.coordinates);
      }

      return null;
    },

    handleClose () {
      this.handleReset(); // 关闭时重置表单
      this.$emit('close');
    },

    getQueryTypeList () {
      // 构建查询参数
      const queryKey = `${this.form.queryType}-${this.form.queryProperty}`;
      console.log('queryKey:', queryKey);
      const propertyName = this.queryRules[queryKey];
      console.log('propertyName:', propertyName);
      if (!propertyName) {
        console.warn('未找到对应的属性名:', queryKey);
        return;
      }

      // 根据 queryType 选择不同的 API 方法
      let apiPromise;
      if (this.form.queryType === 'search_pipe_network') {
        // 物探点 - 使用 listPipeNetworkByGroupProperties
        apiPromise = listPipeNetworkByGroupProperties(propertyName);
      } else if (this.form.queryType === 'search_gis_pipe_line') {
        // 管线 - 使用 listByGroupProperties
        apiPromise = listByGroupProperties(propertyName);
      } else {
        console.warn('不支持的查询类型:', this.form.queryType);
        return;
      }

      apiPromise.then((res) => {
        this.textureList = res.data || [];
        console.log('获取到的数据:', this.textureList);
      }).catch((error) => {
        console.error('获取查询类型列表失败:', error);
      });
    },

    // 处理选择器变化
    handleChange (value) {
      console.log('选择的属性值:', value);
      this.form.queryPropertyValue = value;
    },

    // 检查是否有有效的查询规则
    hasValidQueryRule () {
      if (!this.form.queryType || !this.form.queryProperty) {
        return false;
      }

      const queryKey = `${this.form.queryType}-${this.form.queryProperty}`;
      return this.queryRules.hasOwnProperty(queryKey);
    },

    // 执行查询
    async handleQuery () {
      // 表单验证
      this.$refs.form.validate(async (valid) => {
        // 清除图层
        this.$emit('clear-layer', this.componentsId);
        if (valid) {
          this.lineLength = 0;
          let cqlWhere = ''

          if (this.form.queryPropertyValue && Array.isArray(this.form.queryPropertyValue)) {
            cqlWhere = `(${this.form.queryPropertyValue.map((item, index) => `${index === 0 ? '' : ' or '}${this.form.queryProperty}='${item}'`).join('')})`
            if (this.form.queryType === 'search_gis_pipe_line') {
              // 动态构建参数对象
              this.form.queryPropertyValue.forEach(async (item, index) => {
                let params = { tenantId: this.$store.state.user.info.tenantId };
                // 将下划线格式转换为驼峰格式
                const camelCaseKey = this.toCamelCase(this.form.queryProperty);
                params[camelCaseKey] = item;
                let line = await this.getLineLength(params);
                this.lineLength += Number(line);
              });
            }
          } else if (this.form.queryProperty === 'line_class_no') {
            cqlWhere = `(start_class_no='${this.form.queryPropertyValue}' or end_class_no='${this.form.queryPropertyValue}')`
          }
          else if (this.form.queryProperty === 'user_point_number') {
            let userData = await this.getUserData({ userNo: this.form.queryPropertyValue });
            cqlWhere = `(class_no='${userData.classNo}')`
          } else if (this.form.queryProperty === 'user_point_name') {
            let userData = await this.getUserData({ userNikeName: this.form.queryPropertyValue });
            cqlWhere = `(class_no='${userData.classNo}')`
          }
          else {
            cqlWhere = `${this.form.queryProperty}='${this.form.queryPropertyValue}'`
          }
          let showFilterCondition = `is_deleted = false and tenant_id = '${this.$store.state.user.info.tenantId}' and ${cqlWhere}`

          // 根据查询类型选择对应的 URL
          const cqlUrl = this.form.queryType === 'search_pipe_network' ? this.getNetWorkCQLUrl : this.form.queryType === 'gis_pipe_network_user_data' ? this.getNetWorkCQLUrl : this.getLineCQLUrl
          if (this.form.queryProperty === 'line_class_no' || this.form.queryProperty === 'class_no'
            || this.form.queryProperty === 'user_point_number' || this.form.queryProperty === 'user_point_name') {
            // 查询坐标定位
            this.$http.get(cqlUrl, {
              params: { cql: showFilterCondition }
            }).then((res) => {
              console.log(res.data)
              let geoJson = null
              let coordinates = null

              if (res.data) {
                // 判断res.data是数组还是对象
                const geoJsonStr = Array.isArray(res.data) ? res.data[0].geoJson : res.data.geoJson

                if (geoJsonStr) {
                  geoJson = JSON.parse(geoJsonStr)
                  console.log('解析后的 GeoJSON:', geoJson)

                  // 根据 GeoJSON 类型获取坐标
                  coordinates = this.getCoordinatesByGeoJsonType(geoJson)
                  console.log('最终坐标:', coordinates)

                  // 如果获取到坐标，发送定位事件
                  if (coordinates && coordinates.length === 2) {
                    this.$emit('location-map', {
                      longitude: coordinates[0],
                      latitude: coordinates[1]
                    })
                  }
                }
              }
            }).catch((error) => {
              console.error('查询坐标失败:', error)
            })
          }


          // 构建查询参数
          const queryParams = {
            id: this.componentsId,
            name: '查询图层',
            workspace: 'smart_water',
            dataSource: `smart_water:${this.form.queryType === 'gis_pipe_network_user_data' ? 'search_pipe_network' : this.form.queryType}`,
            showFilterCondition,
          };

          console.log('查询参数:', queryParams);
          // 发送查询事件给父组件
          this.$emit('query-search', queryParams);

          // // 关闭抽屉
          // this.$emit('close');
        } else {
          console.log('表单验证失败');
        }
      });
    },

    async getLine (params) {
      try {
        const res = await this.$http.get(this.getLineUrl, { params });
        return res.data.list[0];
      } catch (error) {
        console.error('获取管线数据失败:', error);
        return null;
      }
    },
    async getUserData (params) {
      const res = await this.$http.get(this.getUserDataUrl, { params });
      return res.data.list[0];
    },
    async getLineLength (params) {
      const res = await this.$http.get(this.getLineLengthUrl, { params });
      return res.data;
    },
    // 重置表单
    handleReset () {
      this.lineLength = 0;
      this.$refs.form.resetFields();
      this.textureList = [];
      // 通知父组件清除指定ID的图层
      this.$emit('clear-layer', this.componentsId);
      console.log('表单已重置');
    }
  }
}
</script>

<style lang="less" scoped>
// 查询抽屉内容样式
.query-content {
  padding: 20px;

  h3 {
    color: #1890ff;
    margin-bottom: 15px;
    text-align: center;
  }

  p {
    color: #666;
    text-align: center;
    margin-bottom: 20px;
  }
}
</style>
